<template>
  <generic-update :model="model">
    <template v-slot:form="{ error, fetch, item, loading, submit }">
      <show-form
        :with-data="item"
        :error="error"
        :loading="loading"
        @submit="submit"
        @reset="fetch"
      ></show-form>
    </template>
  </generic-update>
</template>

<script>
// import { mapState } from "vuex"

import ShowForm from "./Form"
import model from "./model"

export default {
  components: { ShowForm },
  data() {
    return {
      model,
      localData: {},
    }
  },
  created() {
    if (!this.profile.is_staff) {
      this.$router.push({
        name: "ShowPersonOptions",
        params: { id: this.$route.params.id },
      })
    }
  },
}
</script>
